<template>
  <div
    class="shop-listing"
    :class="{ following: isShopFollowed }"
    @click="toggleFollowCell"
  >
    <div class="avatar" @click="goToShop">
      <img :src="shop.thumbnail" alt="" />
    </div>
    <div class="info" @click="goToShop">
      <h4 class="artist-name">{{ shop.name }}</h4>
    </div>
    <div class="actions">
      <font-awesome-icon
        icon="bell-slash"
        size="2x"
        class="action bell"
        v-if="isBellMuted"
        @click.stop="unmuteAlerts"
      />
      <img
        src="../assets/bell.png"
        alt=""
        class="action bell active"
        v-if="isBellUnmuted"
        @click.stop="muteAlerts"
      />
      <font-awesome-icon
        :icon="followIcon"
        size="2x"
        class="action follow"
        @click.stop="toggleFollow"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ShopListing",
  props: {
    shop: {
      type: Object,
    },
    canClickCell: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      isFollowed: "shop/isShopFollowed",
      doesShopAllowAlerts: "shop/doesShopAllowAlerts",
    }),
    isShopFollowed() {
      return this.isFollowed(this.shop.id);
    },
    followIcon() {
      return this.isShopFollowed ? "check-circle" : "plus-circle";
    },
    isBellUnmuted() {
      return this.isShopFollowed && this.doesShopAllowAlerts(this.shop);
    },
    isBellMuted() {
      return this.isShopFollowed && !this.doesShopAllowAlerts(this.shop);
    },
  },
  methods: {
    goToShop() {
      this.$router.push(`/shop/${this.shop.id}`);
    },
    toggleFollowCell() {
      if (this.canClickCell) {
        this.toggleFollow();
      }
    },
    toggleFollow() {
      if (this.isShopFollowed) {
        this.$emit("onUnfollow");
      } else {
        this.$emit("onFollow");
      }
    },
    unmuteAlerts() {
      if (!this.doesShopAllowAlerts(this.shop)) {
        this.$emit("onUnmute");
        this.$store.dispatch("shop/unmuteAlertsForShop", this.shop);
      }
    },
    muteAlerts() {
      if (this.doesShopAllowAlerts(this.shop)) {
        this.$emit("onMute");
        this.$store.dispatch("shop/muteAlertsForShop", this.shop);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.shop-listing {
  display: flex;
  border-radius: 8px;
  padding: 6px;
  background: #6a9dd1aa;
  justify-content: space-between;
  height: 70px;
  margin-bottom: 4px;
  border: 2px solid transparent;
  &.following {
    border-color: rgb(223, 231, 248);
  }
}
.avatar {
  height: 55px;
  width: 55px;
  background: white;
  min-width: 55px;
  img {
    object-fit: contain;
    height: 100%;
    width: 100%;
  }
}
.info {
  flex-grow: 1;
  align-items: center;
  .artist-name {
    height: 100%;
    margin-bottom: 0;
    margin-left: 10px;
    font-size: 16px;
    letter-spacing: 0.02em;
    display: flex;
    align-items: center;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: start;
  }
}
.actions {
  display: flex;
  align-items: center;
  .action {
    margin: 0 8px;
    width: 0.7em;
  }
  .bell {
    &.active {
      width: 21px;
    }
  }
  // .bell {
  //   visibility: hidden;
  // }
}
</style>
